// Day.js configuration with required plugins
// This file centralizes dayjs setup to replace moment.js throughout the application

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import relativeTime from 'dayjs/plugin/relativeTime'
import localeData from 'dayjs/plugin/localeData'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isToday from 'dayjs/plugin/isToday'
import isYesterday from 'dayjs/plugin/isYesterday'

// Extend dayjs with required plugins
dayjs.extend(utc)
dayjs.extend(relativeTime) // For fromNow() functionality
dayjs.extend(localeData) // For locale data
dayjs.extend(isSameOrAfter) // For isAfter() functionality
dayjs.extend(isSameOrBefore) // For isBefore() functionality
dayjs.extend(customParseFormat) // For custom date parsing
dayjs.extend(isToday)
dayjs.extend(isYesterday)

export default dayjs

export const formatDate = (date: Date | string): string => {
  const d = dayjs(date)
  return d.isValid() ? d.format('MMM D, YYYY, hh:mm A') : ''
}

export const formatListDate = (date: Date | string): string => {
  const d = dayjs(date)
  if (!d.isValid()) return ''
  const time = d.format('hh:mm A')
  if (d.isToday()) return `Today ${time}`
  if (d.isYesterday()) return `Yesterday ${time}`
  const datePart = d.year() === dayjs().year() ? d.format('MMM D') : d.format('MMM D, YYYY')
  return `${datePart} ${time}`
}
